import React, { useCallback } from 'react';
import { NavLink, Link } from 'react-router-dom';

import { useSession } from '../../providers/SessionProvider';

function SideMenu() {
  const { isAssessoryMenuSelected, setIsAssessoryMenuSelected } = useSession();

  const handleAssessoryMenuClick = useCallback(() => {
    const isSelected = !isAssessoryMenuSelected;
    setIsAssessoryMenuSelected(isSelected);
    console.log(isSelected);
  }, []);

  return (
    <nav>
      <ul>
        <li>
          <NavLink to="/home" activeClassName="active">
            <i>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="15.494"
                height="17.674"
                viewBox="0 0 15.494 17.674"
              >
                <g id="credit-card" transform="translate(0.15 0.15)">
                  <path
                    id="Path_2942"
                    data-name="Path 2942"
                    d="M45.727,4.362H44.055V1.6a1.6,1.6,0,0,0-1.6-1.6H33.732a1.6,1.6,0,0,0-1.6,1.6V15.775a1.6,1.6,0,0,0,1.6,1.6h8.723a1.6,1.6,0,0,0,1.6-1.6V13.013h1.672a1.6,1.6,0,0,0,1.6-1.6V5.961A1.6,1.6,0,0,0,45.727,4.362Zm-9.3-3.344h3.344V1.6a.582.582,0,0,1-.581.581H37a.582.582,0,0,1-.581-.581Zm6.615,14.757a.582.582,0,0,1-.581.581H33.732a.581.581,0,0,1-.581-.581V1.6a.581.581,0,0,1,.581-.581H35.4V1.6A1.6,1.6,0,0,0,37,3.2h2.181a1.6,1.6,0,0,0,1.6-1.6V1.018h1.672a.582.582,0,0,1,.581.581V4.362H35.913a1.6,1.6,0,0,0-1.6,1.6v5.452a1.6,1.6,0,0,0,1.6,1.6h7.124Zm3.271-4.362a.581.581,0,0,1-.581.581H35.913a.581.581,0,0,1-.581-.581V8.106H46.309v3.307Zm0-4.325H35.332V5.961a.581.581,0,0,1,.581-.581h9.814a.581.581,0,0,1,.581.581V7.088Z"
                    transform="translate(-32.133 0)"
                    fill="#8497a2"
                    stroke="#8497a2"
                    strokeWidth="0.3"
                  />
                  <path
                    id="Path_2943"
                    data-name="Path 2943"
                    d="M145.109,418.751h3.271a.509.509,0,1,0,0-1.018h-3.271a.509.509,0,1,0,0,1.018Z"
                    transform="translate(-140.783 -403.557)"
                    fill="#8497a2"
                    stroke="#8497a2"
                    strokeWidth="0.3"
                  />
                  <path
                    id="Path_2944"
                    data-name="Path 2944"
                    d="M353.976,290.218h1.09a.509.509,0,0,0,0-1.018h-1.09a.509.509,0,0,0,0,1.018Z"
                    transform="translate(-342.563 -279.386)"
                    fill="#8497a2"
                    stroke="#8497a2"
                    strokeWidth="0.3"
                  />
                </g>
              </svg>
            </i>
            Carteira digital
          </NavLink>
        </li>
        <li>
          <NavLink to="/profile">
            <i>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="15.568"
                height="19.636"
                viewBox="0 0 15.568 19.636"
              >
                <path
                  id="resume"
                  d="M8.9,13.728l-4.562,0h0a.767.767,0,0,1,0-1.534l4.562,0h0a.767.767,0,0,1,0,1.534ZM7.861,14.993,4.335,15a.767.767,0,0,0,0,1.534h0l3.526,0a.767.767,0,0,0,0-1.534Zm7.982-.143L11.28,19.409h0l0,0c-.017.016-.034.032-.052.047l-.014.011c-.015.012-.03.023-.046.034l-.013.008c-.017.011-.034.021-.051.031l-.009,0c-.019.01-.039.019-.059.028l0,0c-.021.009-.043.017-.065.024h-.005c-.022.006-.044.012-.067.017l-.016,0-.059.009a.763.763,0,0,1-.076,0l-7.169,0A3.072,3.072,0,0,1,.5,16.568V3.068A3.071,3.071,0,0,1,3.568,0H13a3.072,3.072,0,0,1,3.068,3.068v7.4a.767.767,0,0,1-1.534,0v-7.4A1.536,1.536,0,0,0,13,1.534H3.568A1.536,1.536,0,0,0,2.034,3.068v13.5A1.536,1.536,0,0,0,3.568,18.1l6.4,0V16.225a2.688,2.688,0,0,1,2.685-2.685H15.3c.025,0,.051,0,.076,0l.032,0,.042.006.039.009.034.009.038.013.033.012.036.017.032.015.035.021.03.018.04.029.021.015a.769.769,0,0,1,.108.108l.014.019c.01.014.021.027.03.041l.016.027c.008.012.015.025.022.038l.014.028c.006.013.013.026.018.04s.007.018.01.028.011.029.015.043,0,.018.007.027.008.031.011.046,0,.019,0,.028.005.03.007.046,0,.027,0,.04,0,.023,0,.034,0,.022,0,.033,0,.028,0,.041,0,.031-.007.046,0,.019,0,.028-.007.031-.011.047,0,.018-.007.026-.01.029-.015.044-.006.018-.01.027-.012.027-.018.04l-.014.028c-.007.013-.015.025-.022.038l-.016.027c-.01.015-.021.028-.031.042l-.013.018C15.878,14.813,15.861,14.832,15.843,14.85ZM11.5,16.225v.791l1.944-1.942h-.793A1.152,1.152,0,0,0,11.5,16.225Zm-.81-5.486H5.8A1.274,1.274,0,0,1,4.554,9.2,3.759,3.759,0,0,1,6.3,6.754a2.416,2.416,0,1,1,3.9,0A3.759,3.759,0,0,1,11.94,9.2a1.274,1.274,0,0,1-1.246,1.536ZM7.365,5.331a.882.882,0,1,0,.882-.882A.883.883,0,0,0,7.365,5.331ZM10.349,9.2A2.229,2.229,0,0,0,8.267,7.747h-.04A2.229,2.229,0,0,0,6.144,9.2Zm0,0"
                  transform="translate(-0.5)"
                  fill="#8699a3"
                />
              </svg>
            </i>
            Minha página
          </NavLink>
        </li>
        <li className={isAssessoryMenuSelected ? 'active' : ''}>
          <label htmlFor="sub-menu">
            <i>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18.78"
                height="19.589"
                viewBox="0 0 18.78 19.589"
              >
                <g id="accept" transform="translate(0.15 0.15)">
                  <path
                    id="Path_2932"
                    data-name="Path 2932"
                    d="M65.7,98.637H62.323a.565.565,0,1,0,0,1.13H65.7a.565.565,0,0,0,0-1.13Zm0,0"
                    transform="translate(-59.431 -94.921)"
                    fill="#8699a3"
                    stroke="#8699a3"
                    strokeWidth="0.3"
                  />
                  <path
                    id="Path_2933"
                    data-name="Path 2933"
                    d="M65.7,158.641H62.323a.565.565,0,1,0,0,1.13H65.7a.565.565,0,0,0,0-1.13Zm0,0"
                    transform="translate(-59.431 -152.664)"
                    fill="#8699a3"
                    stroke="#8699a3"
                    strokeWidth="0.3"
                  />
                  <path
                    id="Path_2934"
                    data-name="Path 2934"
                    d="M65.7,218.645H62.323a.565.565,0,1,0,0,1.13H65.7a.565.565,0,0,0,0-1.13Zm0,0"
                    transform="translate(-59.431 -210.408)"
                    fill="#8699a3"
                    stroke="#8699a3"
                    strokeWidth="0.3"
                  />
                  <path
                    id="Path_2935"
                    data-name="Path 2935"
                    d="M65.7,278.648H62.323a.565.565,0,1,0,0,1.13H65.7a.565.565,0,0,0,0-1.13Zm0,0"
                    transform="translate(-59.431 -268.151)"
                    fill="#8699a3"
                    stroke="#8699a3"
                    strokeWidth="0.3"
                  />
                  <path
                    id="Path_2936"
                    data-name="Path 2936"
                    d="M65.7,339.656H62.323a.565.565,0,1,0,0,1.13H65.7a.565.565,0,1,0,0-1.13Zm0,0"
                    transform="translate(-59.431 -326.86)"
                    fill="#8699a3"
                    stroke="#8699a3"
                    strokeWidth="0.3"
                  />
                  <path
                    id="Path_2937"
                    data-name="Path 2937"
                    d="M202.221,99.767h3.373a.565.565,0,1,0,0-1.13h-3.373a.565.565,0,0,0,0,1.13Zm0,0"
                    transform="translate(-194.059 -94.921)"
                    fill="#8699a3"
                    stroke="#8699a3"
                    strokeWidth="0.3"
                  />
                  <path
                    id="Path_2938"
                    data-name="Path 2938"
                    d="M202.221,159.771h3.373a.565.565,0,0,0,0-1.13h-3.373a.565.565,0,0,0,0,1.13Zm0,0"
                    transform="translate(-194.059 -152.664)"
                    fill="#8699a3"
                    stroke="#8699a3"
                    strokeWidth="0.3"
                  />
                  <path
                    id="Path_2939"
                    data-name="Path 2939"
                    d="M204.411,219.21a.565.565,0,0,0-.565-.565h-1.624a.565.565,0,0,0,0,1.13h1.624A.565.565,0,0,0,204.411,219.21Zm0,0"
                    transform="translate(-194.059 -210.408)"
                    fill="#8699a3"
                    stroke="#8699a3"
                    strokeWidth="0.3"
                  />
                  <path
                    id="Path_2940"
                    data-name="Path 2940"
                    d="M313.48,342.812a.565.565,0,0,0-.794.087l-1.455,1.814-.9-.653a.565.565,0,1,0-.663.915l1.337.968a.565.565,0,0,0,.772-.1l1.792-2.234A.565.565,0,0,0,313.48,342.812Zm0,0"
                    transform="translate(-297.775 -329.778)"
                    fill="#8699a3"
                    stroke="#8699a3"
                    strokeWidth="0.3"
                  />
                  <path
                    id="Path_2941"
                    data-name="Path 2941"
                    d="M17.133,11.3a4.66,4.66,0,0,0-2.707-1.36V2.276A2.278,2.278,0,0,0,12.151,0H2.276A2.279,2.279,0,0,0,0,2.276v13.09a2.279,2.279,0,0,0,2.276,2.276h7.942a4.652,4.652,0,0,0,3.569,1.646A4.7,4.7,0,0,0,17.133,11.3Zm-16,4.066V2.276A1.147,1.147,0,0,1,2.276,1.13h9.875A1.147,1.147,0,0,1,13.3,2.276V9.922A4.7,4.7,0,0,0,9.5,16.512H2.276A1.147,1.147,0,0,1,1.13,15.366Zm12.657,2.792a3.566,3.566,0,0,1,0-7.132h.064a3.566,3.566,0,0,1-.064,7.132Zm0,0"
                    fill="#8699a3"
                    stroke="#8699a3"
                    strokeWidth="0.3"
                  />
                </g>
              </svg>
            </i>
            Assessoria jurídica
          </label>
          <input type="checkbox" name="sub-menu" id="sub-menu" />
          <div className="bubble">
            <div className="sub">
              <p>
                <NavLink activeClassName="active" exact to="/contracts">
                  Modelos de contratos
                </NavLink>
              </p>
              <p>
                <NavLink activeClassName="active" exact to="/faq">
                  Dúvidas frequentes
                </NavLink>
              </p>
              <p>
                <NavLink activeClassName="active" exact to="/faq/send">
                  Envie suas dúvidas
                </NavLink>
              </p>
            </div>
          </div>
        </li>
        {/* <li>
          <NavLink to="/courses">
            <i>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20.154"
                height="20.232"
                viewBox="0 0 20.154 20.232"
              >
                <g id="online-className" transform="translate(0.15 0.15)">
                  <path
                    id="Path_2945"
                    data-name="Path 2945"
                    d="M19.3,15V13.08a1.723,1.723,0,0,0-.677-1.336l-.03-.023a1.827,1.827,0,0,0-.851-2.867v-7.1A1.754,1.754,0,0,0,15.988,0H5.866A1.754,1.754,0,0,0,4.114,1.752v7.1a1.827,1.827,0,0,0-.85,2.868,1.721,1.721,0,0,0-.707,1.357V15A1.754,1.754,0,0,0,1,16.74v1.44a1.754,1.754,0,0,0,1.752,1.752H19.1a1.754,1.754,0,0,0,1.752-1.752V16.74A1.754,1.754,0,0,0,19.3,15Zm-6.229-.011V13.08a1.723,1.723,0,0,0-.677-1.336l-.03-.023a1.827,1.827,0,0,0,.3-.549h2.762a1.828,1.828,0,0,0,.3.55,1.721,1.721,0,0,0-.707,1.357v1.908Zm-6.229,0V13.08a1.723,1.723,0,0,0-.677-1.336l-.03-.023a1.827,1.827,0,0,0,.3-.549H9.194a1.828,1.828,0,0,0,.3.55,1.721,1.721,0,0,0-.707,1.357v1.908ZM3.725,13.08c0-.353.455-.662.973-.662a1.192,1.192,0,0,1,.735.238.575.575,0,0,1,.238.424v1.908H3.725Zm7.2-1.83a.662.662,0,1,1,.662-.662A.663.663,0,0,1,10.927,11.251Zm-.973,1.83c0-.353.455-.662.973-.662a1.192,1.192,0,0,1,.735.238.575.575,0,0,1,.238.424v1.908H9.954Zm6.229,0c0-.353.455-.662.973-.662a1.192,1.192,0,0,1,.735.238.575.575,0,0,1,.238.424v1.908H16.183Zm.973-1.83a.662.662,0,1,1,.662-.662A.663.663,0,0,1,17.156,11.251ZM5.866,1.168H15.988a.585.585,0,0,1,.584.584v7.1a1.838,1.838,0,0,0-1.15,1.15H12.661a1.829,1.829,0,0,0-3.467,0H6.432a1.838,1.838,0,0,0-1.15-1.15v-7.1a.585.585,0,0,1,.584-.584Zm-1.83,9.421a.662.662,0,1,1,.662.662A.663.663,0,0,1,4.037,10.589Zm15.65,7.591a.585.585,0,0,1-.584.584H2.752a.585.585,0,0,1-.584-.584V16.74a.585.585,0,0,1,.584-.584H19.1a.585.585,0,0,1,.584.584Z"
                    transform="translate(-1 0)"
                    fill="#8598a2"
                    stroke="#8598a2"
                    strokeWidth="0.3"
                  />
                  <path
                    id="Path_2946"
                    data-name="Path 2946"
                    d="M214.036,75.06a.96.96,0,0,0,.992-.056l2.182-1.491a.962.962,0,0,0,0-1.586h0l-2.182-1.509a.962.962,0,0,0-1.51.791v3A.96.96,0,0,0,214.036,75.06Zm.655-3.459,1.613,1.116-1.613,1.1Z"
                    transform="translate(-205.249 -67.512)"
                    fill="#8598a2"
                    stroke="#8598a2"
                    strokeWidth="0.3"
                  />
                </g>
              </svg>
            </i>
            Cursos online
          </NavLink>
        </li> */}
        <li>
          <a
            href="http://www.tickettravel.com.br"
            rel="noreferrer"
            target="_blank"
          >
            <i>
              <svg
                id="ticket"
                xmlns="http://www.w3.org/2000/svg"
                width="17.481"
                height="16.108"
                viewBox="0 0 17.481 16.108"
              >
                <g
                  id="Group_3216"
                  data-name="Group 3216"
                  transform="translate(0 0)"
                >
                  <g id="Group_3215" data-name="Group 3215">
                    <circle
                      id="Ellipse_51"
                      data-name="Ellipse 51"
                      cx="0.683"
                      cy="0.683"
                      r="0.683"
                      transform="translate(11.267 11.67)"
                      fill="#8497a2"
                    />
                    <path
                      id="Path_2947"
                      data-name="Path 2947"
                      d="M115.463,221.9h-4.78a.683.683,0,0,0,0,1.366h4.78a.683.683,0,0,0,0-1.366Z"
                      transform="translate(-106.244 -215.009)"
                      fill="#8497a2"
                    />
                    <path
                      id="Path_2948"
                      data-name="Path 2948"
                      d="M113.824,291.9h-3.141a.683.683,0,1,0,0,1.366h3.141a.683.683,0,1,0,0-1.366Z"
                      transform="translate(-106.244 -282.619)"
                      fill="#8497a2"
                    />
                    <path
                      id="Path_2949"
                      data-name="Path 2949"
                      d="M16.934,29.06a.683.683,0,0,0,.547-.669V26.649a2.735,2.735,0,0,0-2.731-2.731H2.731a2.731,2.731,0,0,0-.576.062,1.391,1.391,0,0,1,.277-.094L13.11,21.493a1.2,1.2,0,0,1,1.352.686.683.683,0,0,0,1.249-.552,2.574,2.574,0,0,0-2.893-1.468h0L2.134,22.553A2.731,2.731,0,0,0,0,25.218V28.39a.683.683,0,0,0,.547.669,1.025,1.025,0,0,1,0,2.007A.683.683,0,0,0,0,31.736v1.741a2.735,2.735,0,0,0,2.731,2.731H14.75a2.735,2.735,0,0,0,2.731-2.731V31.736a.683.683,0,0,0-.547-.669,1.025,1.025,0,0,1,0-2.007ZM16.115,27.9a2.39,2.39,0,0,0,0,4.319v1.255a1.367,1.367,0,0,1-1.366,1.366H12.633a.683.683,0,0,0-1.366,0H2.731a1.367,1.367,0,0,1-1.366-1.366V32.223a2.39,2.39,0,0,0,0-4.319V26.649a1.367,1.367,0,0,1,1.366-1.366h8.536a.683.683,0,0,0,1.366,0H14.75a1.367,1.367,0,0,1,1.366,1.366Z"
                      transform="translate(0 -20.101)"
                      fill="#8497a2"
                    />
                    <circle
                      id="Ellipse_52"
                      data-name="Ellipse 52"
                      cx="0.683"
                      cy="0.683"
                      r="0.683"
                      transform="translate(11.267 6.89)"
                      fill="#8497a2"
                    />
                    <circle
                      id="Ellipse_53"
                      data-name="Ellipse 53"
                      cx="0.683"
                      cy="0.683"
                      r="0.683"
                      transform="translate(11.267 9.28)"
                      fill="#8497a2"
                    />
                  </g>
                </g>
              </svg>
            </i>
            Passagens e hotéis
          </a>
        </li>
      </ul>
    </nav>
  );
}

export default SideMenu;
